import React from "react";
import { Link } from "react-router";
import { fetchItemGroupListFn } from "../item-groups.api";
import ItemGroupEditor from "../components/ItemGroupEditor";


export const ItemGroupListPage = () => {

    const [items, setItems] = React.useState<any[]>([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [error, setError] = React.useState<any>(null);
    const [editingGroupId, setEditingGroupId] = React.useState<string | null>(null);

    const loadGroups = React.useCallback(() => {
        setIsLoading(true);
        fetchItemGroupListFn()
            .then(data => {
                setItems(data);
                setError(null);
            })
            .catch(err => {
                setError(err);
                setItems([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    React.useEffect(() => { loadGroups(); }, [loadGroups]);

    const openGroupEdit = (event: React.MouseEvent<HTMLAnchorElement>, groupId: string) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        setEditingGroupId(groupId);
    };

    const errorMessage = error ? "데이터를 불러올 수 없습니다." : "";

    return (<>
        {errorMessage && (
            <div className="alert alert-danger" role="alert">
                {errorMessage}
            </div>
        )}

        <div className="page-head page-head-standard d-flex justify-content-between align-items-center mb-0">
            <div>
                <p className="fs-5">
                    상품그룹
                </p>
            </div>
            <div>
                <Link to="/itemgroups/new" className="btn btn-primary">그룹등록</Link>
            </div>
        </div>

        <table className="table data-table-card">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">그룹명</th>
                    <th scope="col">그룹메모</th>
                    <th scope="col">우선순위</th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading &&
                    <tr><td colSpan={100} style={{ height: 100, textAlign: 'center', verticalAlign: 'middle' }}>로딩 중입니다.</td></tr>
                }
                {!isLoading && items && items.length < 1 &&
                    <tr><td colSpan={100} style={{ height: 100, textAlign: 'center', verticalAlign: 'middle' }}>등록된 상품이 없습니다.</td></tr>
                }
                {!isLoading && items && items.map((item: any, index: number) => (
                    <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td><Link to={`/itemgroups/${item.id}`} onClick={(event) => openGroupEdit(event, String(item.id))}>{item.name}</Link></td>
                        <td>{item.description}</td>
                        <td>{item.sort_order}</td>
                    </tr>
                ))}
            </tbody>
        </table>
        {editingGroupId && (
            <ItemGroupEditor
                key={editingGroupId}
                groupId={editingGroupId}
                onClose={() => setEditingGroupId(null)}
                onChanged={() => { setEditingGroupId(null); loadGroups(); }}
            />
        )}
    </>)
}

export default ItemGroupListPage;
